// postgresql versions
export const DEFAULT_DB_VERSION = 18
export const DB_VERSIONS = [DEFAULT_DB_VERSION, 17, 16, 15, 14, 13, 12, 11, 10]
// os types
export const OS_LINUX = 'linux'
export const OS_WINDOWS = 'windows'
export const OS_MAC = 'mac'
// db types
export const DB_TYPE_WEB = 'web'
export const DB_TYPE_OLTP = 'oltp'
export const DB_TYPE_DW = 'dw'
export const DB_TYPE_DESKTOP = 'desktop'
export const DB_TYPE_MIXED = 'mixed'
// size units
export const SIZE_UNIT_MB = 'MB'
export const SIZE_UNIT_GB = 'GB'
export const SIZE_UNIT_TB = 'TB'
// harddrive types
export const HARD_DRIVE_SSD = 'ssd'
export const HARD_DRIVE_SAN = 'san'
export const HARD_DRIVE_HDD = 'hdd'
export const HARD_DRIVE_NVME = 'nvme'
// database size vs ram
export const DB_SIZE_LESS_RAM = 'less_ram'
export const DB_SIZE_MID_RAM = 'mid_ram'
export const DB_SIZE_GREATER_RAM = 'greater_ram'
// maximum value for integer fields
export const MAX_NUMERIC_VALUE = 999999
